import { ActionType } from '../action-types';
import installerInitialState from './init/installerInitialState';

const installerReducer = (state = installerInitialState, action) => {
	let currentSystem;

	switch (action.type) {
		case ActionType.LOGOUT:
		case ActionType.LOGIN_SUCCESS:
			return installerInitialState;
		case ActionType.SYSTEM_SAVE_SUCCESSFULLY:
			return {
				...state,
				systemSaveSuccessfully: true,
				systemSaveFail: false,
			};
		case ActionType.SYSTEM_SAVE_FAIL:
			return {
				...state,
				systemSaveSuccessfully: false,
				systemSaveFail: true,
			};
		case ActionType.CLOSE_NOTIFICATION:
			return {
				...state,
				systemSaveSuccessfully: false,
				systemSaveFail: false
			};
		case ActionType.SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY:
			return {
				...state,
				saveParametersSettingsSuccessfully: true,
				saveParametersSettingsFailed: false,
			};
		case ActionType.SAVE_PARAMETERS_SETTINGS_FAILED:
			return {
				...state,
				saveParametersSettingsSuccessfully: false,
				saveParametersSettingsFailed: true,
				saveParametersSettingsFailedReason: action.reason
			};
		case ActionType.CLOSE_SAVE_PARAMETERS_SETTINGS_NOTIFICATION:
			return {
				...state,
				saveParametersSettingsSuccessfully: false,
				saveParametersSettingsFailed: false,
				saveParametersSettingsFailedReason: null
			};
		case ActionType.MAP_UPLOAD_SUCCESS:
			return {
				...state,
				mapUploadSuccessfully: true,
				mapUploadFailed: false,
				systemUpdatedViaWebsiteAt: action.updatedViaWebsiteAt
			};
        case ActionType.GET_SYSTEM_FULL:
            return {
                ...state,
                systemUpdatedViaWebsiteAt: action.systemData.updatedViaWebsiteAt,
            };
		case ActionType.MAP_UPLOAD_FAILED:
			return {
				...state,
				mapUploadSuccessfully: false,
				mapUploadFailed: true,
			};
		case ActionType.CLOSE_MAP_UPLOAD_NOTIFICATION:
			return {
				...state,
				mapUploadSuccessfully: false,
				mapUploadFailed: false,
			};
		case ActionType.SAVE_CLIENT_LOGO_SUCCESSFULLY:
			return {
				...state,
				logoUploadSuccessfully: true,
				logoUploadFailed: false,
			};
		case ActionType.SAVE_CLIENT_LOGO_FAILED:
			return {
				...state,
				logoUploadSuccessfully: false,
				logoUploadFailed: true,
			};
		case ActionType.CLOSE_CLIENT_LOGO_NOTIFICATION:
			return {
				...state,
				logoUploadSuccessfully: false,
				logoUploadFailed: false,
			};
		case ActionType.UPDATE_MAP_UPLOAD_PROGRESS:
			return {
				...state,
				mapUploadProgress: action.payload,
				mainMapUploadProgress: action.payload,

			};
		case ActionType.UPDATE_SECOND_MAP_UPLOAD_PROGRESS:
			return {
				...state,
				//mapUploadProgress: action.payload,
				secondMapUploadProgress: action.payload,

			};
		case ActionType.UPDATE_THIRD_MAP_UPLOAD_PROGRESS:
			return {
				...state,
				//mapUploadProgress: action.payload,
				thirdMapUploadProgress: action.payload,

			};
		case ActionType.DELETE_MAP_SUCCEEDED:
			if (action.mapType == 'second') {
				return {
					...state,
					deleteMapSucceeded: true,
					deleteMapFailed: false,
				}
			}
			return {
				...state,
				deleteMapSucceeded: true,
				deleteMapFailed: false,
			};
		case ActionType.DELETE_MAP_FAILED:
			return {
				...state,
				deleteMapSucceeded: false,
				deleteMapFailed: true,
			};
		case ActionType.UPDATE_REPORT_MAP_UPLOAD_PROGRESS:
			return {
				...state,
				reportMapUploadProgress: action.payload,

			};
		case ActionType.UPDATE_LOGO_UPLOAD_PROGRESS:
			return {
				...state,
				logoUploadProgress: action.payload,
			};
		case ActionType.FAILED_UPLOAD_MAP_FILE:
			return {
				...state,
				failedUploadMapFile: true,
			};
		case ActionType.RESET_UPLOAD_MAP_FILE_STATUS:
			return {
				...state,
				failedUploadMapFile: false,
			};
		case ActionType.FAILED_UPLOAD_LOGO_FILE:
			return {
				...state,
				failedUploadLogoFile: true,
			};
		case ActionType.RESET_UPLOAD_LOGO_FILE_STATUS:
			return {
				...state,
				failedUploadLogoFile: false,
			};
		case ActionType.SAVE_POINTS_FAILED:
			return {
				...state,
				savePointsSuccessfully: false,
				savePointsFailed: true,
			};
		case ActionType.POLYGON_SAVE_FAILED:
			return {
				...state,
				savePolygonsSuccessfully: false,
				savePolygonsFailed: true,
			};
		case ActionType.SAVE_POINTS_SUCCESSFULLY:
			return {
				...state,
				savePointsSuccessfully: true,
				savePointsFailed: false,
			};
		case ActionType.POLYGON_SAVE_SUCCESS:
			return {
				...state,
				savePolygonsSuccessfully: true,
				savePolygonsFailed: false,
                systemUpdatedViaWebsiteAt: action.updatedViaWebsiteAt
			};
		case ActionType.CLOSE_SAVE_POINTS_AND_POLYGONS_NOTIFICATION:
			return {
				...state,
				savePolygonsSuccessfully: false,
				savePointsSuccessfully: false,
				savePolygonsFailed: false,
				savePointsFailed: false,
			};
		case ActionType.DELETE_SYSTEM_SUCCESSFULLY:
			return {
				...state,
				deleteSystemSuccessfully: true,
				deleteSystemFailed: false,
			};
		case ActionType.DELETE_SYSTEM_FAILED:
			return {
				...state,
				deleteSystemSuccessfully: false,
				deleteSystemFailed: true,
			};
		case ActionType.CLOSE_DELETE_SYSTEM_NOTIFICATION:
			return {
				...state,
				deleteSystemSuccessfully: false,
				deleteSystemFailed: false,
			};
		case ActionType.GET_SYSTEMS_FOR_INSTALLER_PANEL:
			return {
				...state,
				systemsForInstallerPanel: action.systems,
			};
		case ActionType.SET_SYSTEM_ARCHIVED_SUCCESSFULLY:
			return {
				...state,
				setSystemArchivedSuccessfully: true,
				setSystemArchivedFailed: false,
				systemsForInstallerPanel: (state.systemsForInstallerPanel || []).map((s) =>
					s.ID === action.systemId ? { ...s, archived: action.archived } : s
				),
			};
		case ActionType.SET_SYSTEM_ARCHIVED_FAILED:
			return {
				...state,
				setSystemArchivedSuccessfully: false,
				setSystemArchivedFailed: true,
			};
		case ActionType.CLOSE_SET_SYSTEM_ARCHIVED_NOTIFICATION:
			return {
				...state,
				setSystemArchivedSuccessfully: false,
				setSystemArchivedFailed: false,
			};
		case ActionType.CLOSE_DELETE_USER_NOTIFICATION:
			return {
				...state,
				deleteUserSucceeded: false,
				deleteUserFailed: false,
			};
		case ActionType.CLOSE_DELETE_MAP_NOTIFICATION:
			return {
				...state,
				deleteMapSucceeded: false,
				deleteMapFailed: false,
			};
		case ActionType.CLOSE_DELETE_SYSTEM_GROUP_NOTIFICATION:
			return {
				...state,
				deleteSystemGroupSuccessfully: false,
				deleteSystemGroupFailed: false,
			};
		case ActionType.DELETE_NODE_SUCCESSFULLY:
			return {
				...state,
				deleteNodeSuccessfully: true,
				deleteNodeFailed: false,
			};
		case ActionType.DELETE_NODE_FAILED:
			return {
				...state,
				deleteNodeSuccessfully: false,
				deleteNodeFailed: true,
			};
		case ActionType.DELETE_ACCOUNT_SUCCEEDED:
			return {
				...state,
				deleteUserSucceeded: true,
				deleteUserFailed: false,
			};
		case ActionType.DELETE_ACCOUNT_FAILED:
			return {
				...state,
				deleteUserSucceeded: false,
				deleteUserFailed: true,
			};
		case ActionType.CLOSE_DELETE_NODE_NOTIFICATION:
			return {
				...state,
				deleteNodeSuccessfully: false,
				deleteNodeFailed: false,
			};
		case ActionType.DELETE_SYSTEM_GROUP_SUCCESSFULLY:
			return {
				...state,
				deleteSystemGroupSuccessfully: true,
				deleteSystemGroupFailed: false,
			};
		case ActionType.DELETE_SYSTEM_GROUP_FAILED:
			return {
				...state,
				deleteSystemGroupSuccessfully: false,
				deleteSystemGroupFailed: true,
			};
		case ActionType.GET_SYSTEM_GROUPS_INSTALLER:
			return {
				...state,
				systemGroups: action.systemGroups
			}
		case ActionType.CREATE_SYSTEM_GROUP:
			return {
				...state,
				systemGroups: action.newID > 0 
					? [...state.systemGroups, {ID: action.newID, name: action.name, isPublic: action.public, public: action.public}] 
					: state.systemGroups
			}
		case ActionType.GET_SYNC_FAILURES:
			return {
				...state,
				syncFailures: action.syncFailures
			}
		case ActionType.DEVICE_ERRORS_LOADING:
			return {
				...state,
				deviceErrorsLoading: true
			}
		case ActionType.GET_DEVICE_ERRORS:
			return {
				...state,
				deviceErrors: action.deviceErrors,
				deviceErrorsLoading: false
			}
		case ActionType.GET_DEVICE_ERRORS_COUNT:
			return {
				...state,
				deviceErrorsCount: action.deviceErrorsCount
			}
		case ActionType.GET_SYSTEM_DETAILS_START:
			return {
				...state,
				systemDetailsLoading: true,
			};
		case ActionType.GET_SYSTEM_DETAILS:
			return {
				...state,
				systemDetails: action.systemDetails,
				systemDetailsLoading: false,
				// systemID: true,
			};
		case ActionType.GET_SYSTEM_DETAILS_FAILED:
			return {
				...state,
				systemDetailsLoading: false,
			};
		case ActionType.GET_DEVICE_DETAILS_START:
			return {
				...state,
				deviceDetailsLoading: true,
			};
		case ActionType.GET_DEVICE_DETAILS:
			return {
				...state,
				deviceDetails: action.deviceDetails,
				deviceDetailsLoading: false,
				// systemID: true,
			};
		case ActionType.GET_DEVICE_DETAILS_FAILED:
			return {
				...state,
				deviceDetailsLoading: false,
			};
		default:
			return state;
	}
};

export default installerReducer;
